import React from 'react';
import '../App.css';

export const Error = (setPredictions) => (
  <>
    <p>Error page</p>
  </>
);
